import { Col } from '@repo/ui/components'
import { WalletCardItem } from './wallet.card-item'
import type { WalletCardsProps } from './wallet.types'

export const WalletCards = ({ wallets }: WalletCardsProps) => {
  return (
    <Col className=''>
      {wallets.map((asset) => (
        <WalletCardItem key={asset.id} asset={asset} />
      ))}
    </Col>
  )
}
